import React from 'react'
import {CopyToClipboard} from "react-copy-to-clipboard";
import TextArea from "./elements/TextArea";
import {ReactComponent as Copy} from "../pages/Icons/size24/Copy.svg";
import notifyUser from "../methods/notifyUser";

type Props = {
    title: string
    value: string
    placeholder?: string
    copyMessage?: string
    onCopy?: () => void
    buttonClassName?: string
    buttonTextClassName?: string
    $store?: any
    $commitToStore?: Function
}

export default function ApiKeyField({ 
    title, 
    value, 
    placeholder = "", 
    copyMessage = "Ключ скопирован в буфер обмена",
    onCopy,
    buttonClassName,
    buttonTextClassName,
    $store,
    $commitToStore
}: Props) {
    function handleCopy() {
        if (onCopy) {
            onCopy()
        } else {
            notifyUser({ $store, $commitToStore }, copyMessage)
        }
    }

    return (
        <div className="titleContainer" style={{marginTop: "15px", gap: "20px"}}>
            <div className="commonLabel" style={{width: "100%"}}>
                <div className="commonLabel" style={{width: "100%"}}>
                    {title}
                </div>

                <TextArea
                    placeholder={placeholder}
                    readOnly
                    value={value}
                    onChange={() => {}}
                />
                <CopyToClipboard
                    onCopy={handleCopy}
                    text={value}
                >
                    <button
                        className={buttonClassName || "new withTitle _wa"}
                        style={{marginTop: "15px"}}
                    >
                        <div className="buttonsContainer">
                            <Copy className="icon" style={{fill: "white"}}/>
                            <span className={buttonTextClassName || undefined}>Скопировать ключ</span>
                        </div>
                    </button>
                </CopyToClipboard>
            </div>
        </div>
    )
}
